import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1496a13d&scoped=true&"
var script = {}
import style0 from "./Category.vue?vue&type=style&index=0&id=1496a13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496a13d",
  null
  
)

export default component.exports